export default "__VITE_ASSET__DKNahzKH__"